<template>
	<b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Nome:</label>
				<b-form-input v-model="jsonData.denominazione"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<b-form-textarea v-model="jsonData.descrizione" rows="7"></b-form-textarea>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<b-form-textarea v-model="jsonData.note" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: {},
	data() {
		return {
			id: null,
			pathResource: "/gestioneattivitaclienti",
			jsonData: { denominazione: "", descrizione: "", note: "" },
		};
	},
	mounted() {
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		init() {},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
